var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBonus3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_1416)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 10.3097V12.7097C13.7475 12.7097 15.39 13.1747 16.8 13.9922V10.3097H43.2V31.9097H38.4H28.8H21.33C23.01 33.1472 24.375 34.7972 25.26 36.7097H43.2C45.8475 36.7097 48 34.5572 48 31.9097V10.3097C48 7.66219 45.8475 5.50969 43.2 5.50969H16.8C14.1525 5.50969 12 7.66219 12 10.3097Z",
    fill: "url(#paint0_linear_2056_1416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 22.3097C4.8 20.4001 5.55857 18.5688 6.90883 17.2185C8.25909 15.8683 10.0904 15.1097 12 15.1097C13.9096 15.1097 15.7409 15.8683 17.0912 17.2185C18.4414 18.5688 19.2 20.4001 19.2 22.3097C19.2 24.2193 18.4414 26.0506 17.0912 27.4009C15.7409 28.7511 13.9096 29.5097 12 29.5097C10.0904 29.5097 8.25909 28.7511 6.90883 27.4009C5.55857 26.0506 4.8 24.2193 4.8 22.3097ZM0 41.9072C0 36.3872 4.4775 31.9097 9.9975 31.9097H13.995C19.5225 31.9097 24 36.3872 24 41.9072C24 43.0097 23.1075 43.9097 21.9975 43.9097H2.0025C0.8925 43.9097 0 43.0172 0 41.9072ZM31.2 27.1097H36C37.3275 27.1097 38.4 28.1822 38.4 29.5097V31.9097H28.8V29.5097C28.8 28.1822 29.8725 27.1097 31.2 27.1097Z",
    fill: "url(#paint1_linear_2056_1416)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2056_1416",
    x1: 47.942,
    y1: 21.1097,
    x2: 25.3738,
    y2: 3.77429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2056_1416",
    x1: 38.3382,
    y1: 29.5097,
    x2: 16.9293,
    y2: 10.5067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8251"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_1416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 38.4,
    fill: "white",
    transform: "translate(0 5.50969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBonus3);
export default __webpack_public_path__ + "static/media/icon-bonus-3.aa8f0f1c4eca7de9c2f973fde0fdc2e1.svg";
export { ForwardRef as ReactComponent };